import { EXCHANGE_ROUTES, EXCHANGE_ROUTES_MAP } from '../model/constants';
export const getExchangePrevPath = (currentPath, { skipPassengers }) => {
    var _a, _b;
    const prevPath = (_b = (_a = EXCHANGE_ROUTES_MAP.get(currentPath)) === null || _a === void 0 ? void 0 : _a.prev) !== null && _b !== void 0 ? _b : null;
    if (!prevPath) {
        return null;
    }
    if (prevPath === EXCHANGE_ROUTES.passengers && skipPassengers) {
        return null;
    }
    return prevPath;
};
